import PubNub from "pubnub";
export const getPubNubService = ({ publishKey, subscribeKey }) => {
  const pubNubObj = {};

  return (userId) => {
    if (!pubNubObj[userId]) pubNubObj[userId] = new PubNub({ publishKey, subscribeKey, userId });
    return pubNubObj[userId];
  };
};
